import { useQuery } from "@tanstack/react-query";
import { OrdersService } from "@/services/orders/orders-service";
import { Order } from "@/pages/orders/orders.types";

const ordersService = new OrdersService();

export const useOrdersQuery = () => {
  return useQuery<Order[], Error>({
    queryKey: ["orders", "amznham"],
    queryFn: async () => {
      const response = await ordersService.getMyOrders();
      return response.orders ?? [];
    },
  });
};
